<template>
  <div class='list'>
    <el-form :model='dioForm' label-width='120px'>
      <el-row>
        <el-col :span='12' v-for='item in baseMsg' :key='item.key'>
          <el-form-item :label='$t(item.text)'>
            <template v-if="item.key === 'description'">
              <span v-if='!isMode'>
                {{ dioForm.description }}
              </span>

              <el-input v-else type='textarea' v-model='areaValue' maxlength='250'
                        :autosize='{ minRows: 3, maxRows: 4 }'
                        style='width: 200px' show-word-limit></el-input>
            </template>

            <template v-else-if="item.key === 'nickname'">
              <span v-if='!isMode'>
                {{ dioForm.nickname }}
              </span>

              <el-input v-else type='text' v-model='nickname' style='width: 200px' maxlength='30'></el-input>
            </template>
            <!-- url需要特殊处理 -->
            <template v-else-if="item.key === 'url'">
              <div style='white-space:nowrap'>{{ currentCarrier.fullPath }}</div>
            </template>
            <span v-else>
              <span>{{ switchFn(item.key, detailObj[item.key]) }}</span>
            </span>

            <!-- 监测点名称 -->
            <template v-if="item.key === 'carrierName'">
              <div>
                <el-select v-model='currentCarrier' value-key='keycode'>
                  <el-option :label='item.keycode' :value='item' :key='item.id'
                             v-for='item in detailObj.carrierRspList'></el-option>
                </el-select>
              </div>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item v-if='isMode'>
        <el-button type='primary' @click='saveDecFn'>
          <i class='el-icon-folder-checked button-icon '></i>
          {{ $t('public.save') }}
        </el-button>
        <el-button type='primary' @click='goBack'><i class='el-icon-refresh-left button-icon'></i>{{ $t('返回') }}
        </el-button>
      </el-form-item>
      <el-form-item v-if='!isMode'>
        <el-button type='primary' @click='goBack'><i class='el-icon-edit button-icon'></i>{{ $t('public.edit') }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { shiquArrayConvert } from '@/utils/convert'
export default {
  props: ['baseMsg', 'isMode', 'detailObj', 'shiquArray'],
  data () {
    return {
      dioForm: {},
      nickname: '',
      areaValue: '',
      currentCarrier: {}
    }
  },

  watch: {
    detailObj (newVal) {
      this.dioForm = { ...newVal }
      if (this.detailObj.carrierRspList.length) {
        this.currentCarrier = this.detailObj.carrierRspList[0]
      }
    }
    // isMode(newVal) {
    //   console.log(newVal);
    //   this.isEdit = newVal

    //   // this.dioForm.isHeart = this.detailObj.isHeart
    // },
  },
  methods: {
    switchFn (key, value) {
      switch (key) {
        case 'configStatus': {
          return value === 0 ? $t('device.wait_config') : value === 1 ? $t('device.configured') : $t('device.configured')
        }
        case 'type': {
          return value === 1 ? $t('deviceType.dt_1') : $t('public.display')
        }
        case 'timeCode': {
          return this.shiquFn(value)
        }
        case 'alarmOn': {
          return value === 1 ? $t('public.btn_yes') : $t('public.btn_no')
        }
        case 'createTime': {
          return this.$timetransition(value)
        }
        case 'stopTime': {
          return this.$timetransition(value)
        }
        // case 'carrierName': {
        //   return this.carrierFn(value)
        // }
        default:
          break
      }
      return value
    },
    carrierFn (carrierName) {
      if (!carrierName) return
      const array = carrierName.split(',')
      return array
        .map((item) => {
          const newArray = item.split('-')
          return newArray[newArray.length - 1]
        })
        .join(',')
    },
    shiquFn (type) {
      if (!type && type !== 0) return
      let str = ''

      for (const item of this.shiquArray) {
        if (type === item.code) {
          // str = item.name
          str = $t(shiquArrayConvert(item.code))
          break
        }
      }
      return str
    },
    goBack () {
      this.areaValue = this.detailObj.description
      this.nickname = this.detailObj.nickname
      this.$emit('update:isMode', !this.isMode)
    },
    saveDecFn () {
      const { id } = this.dioForm

      this.$emit('saveDecFn', {
        id,
        nickname: this.nickname,
        areaValue: this.areaValue
      })
    }
  }

}
</script>

<style lang='scss' scoped>
.list {
  flex: 1;
}

::v-deep .button-icon {
  margin: 0;
  color: white;
  font-size: 14px;
  font-weight: 100;
  margin-right: 5px;
}

.el-select {
  height: 28px;
}
</style>
